import React, { useState, useEffect, useCallback } from "react";
import {
  FaAward,
  FaBimobject,
  FaCalendarAlt,
  FaDownload,
  FaExternalLinkAlt,
  FaChevronDown,
  FaChevronUp,
  FaList,
  FaUbuntu,
  FaImage,
  FaMemory,
  FaGithub,
  FaDocker,
  FaGit,
  FaNetworkWired,
  FaCloud,
  FaHtml5,
  FaCss3,
  FaJs,
  FaReact,
  FaDatabase,
} from "react-icons/fa";
import {
  BiCode,
  BiData,
  BiGlobe,
  BiLayout,
  BiServer,
  BiShield,
  BiCloudRain,
  BiAtom,
  BiStats,
  BiFile,
  BiNetworkChart,
} from "react-icons/bi";
import "./Certifications.css";
import {
  SiTensorflow,
  SiScikitlearn,
  SiNumpy,
  SiPandas,
  SiOpencv,
  SiKeras,
  SiJupyter,
  SiGraphite,
  SiMongodb,
  SiDictionarydotcom,
  SiKubernetes,
  SiCloud66,
  SiExpress,
  SiRedux,
  SiStreamlit,
  SiPlotly,
  SiGooglecloudstorage,
} from "react-icons/si";
import { SiDeepin } from "react-icons/si";
import { SiAegisauthenticator } from "react-icons/si";

import { RiTailwindCssFill, RiFunctions } from "react-icons/ri";
import { LiaRobotSolid } from "react-icons/lia";
import { BiLogoPostgresql } from "react-icons/bi";
import { PiBracketsRound } from "react-icons/pi";
import { MdDynamicFeed, MdClass, MdOutlineSyncProblem } from "react-icons/md";
import { AiFillAndroid, AiOutlineException } from "react-icons/ai";
import { GrInherit } from "react-icons/gr";
import { FaCodePullRequest, FaUserSecret } from "react-icons/fa6";
import { VscFileSubmodule } from "react-icons/vsc";
import { IoLibraryOutline, IoFileTrayStackedSharp } from "react-icons/io5";
import { DiPython } from "react-icons/di";
import { HiTranslate } from "react-icons/hi";
import { MdOutlineSettingsRemote } from "react-icons/md";
import { BiSolidPackage } from "react-icons/bi";
import { AiOutlineOpenAI } from "react-icons/ai";
import { GoCopilot } from "react-icons/go";
import { PiShareNetworkBold } from "react-icons/pi";
import { TbMathSymbols } from "react-icons/tb";
import { GiPickle } from "react-icons/gi";

import CertificationActions from "./CertificationActions";

// Certification data
const certifications = [
  {
    id: 1,
    name: "Machine Learning Specialization",
    issuer: "Stanford",
    issuerLogo: "certifications/stanford.png",
    completionDate: "March 2024",
    skills: [
      { name: "Tensorflow", icon: <SiTensorflow className="skill-icon" /> },
      { name: "Scikit-learn", icon: <SiScikitlearn className="skill-icon" /> },
      { name: "Numpy", icon: <SiNumpy className="skill-icon" /> },
      { name: "Pandas", icon: <SiPandas className="skill-icon" /> },
      { name: "OpenCv", icon: <SiOpencv className="skill-icon" /> },
      { name: "Keras", icon: <SiKeras className="skill-icon" /> },
      { name: "Jupyter", icon: <SiJupyter className="skill-icon" /> },
      { name: "Seaborn", icon: <SiGraphite className="skill-icon" /> },
      { name: "Streamlit", icon: <SiStreamlit className="skill-icon" /> },
      { name: "Plotly", icon: <SiPlotly className="skill-icon" /> },
      { name: "Pickle", icon: <GiPickle className="skill-icon" /> },
      { name: "Request", icon: <FaCodePullRequest className="skill-icon" /> },
    ],
    certificateUrl: "https://coursera.org/verify/specialization/SXUATYSNB4DF",
    downloadUrl: "https://drive.google.com/file/d/1iw1k0qN4nlKBVwnTyyYn4CGpqVTykRxd/view?usp=sharing",
    color: "#FF9900",
  },
  {
    id: 2,
    name: "Full Stack Web Development",
    issuer: "Meta",
    issuerLogo: "certifications/meta.png",
    completionDate: "September 2025",
    skills: [
      { name: "React", icon: <BiAtom className="skill-icon" /> },
      { name: "Node.js", icon: <BiServer className="skill-icon" /> },
      { name: "MongoDB", icon: <BiData className="skill-icon" /> },
      { name: "RESTful APIs", icon: <BiGlobe className="skill-icon" /> },
      { name: "Tailwind", icon: <RiTailwindCssFill className="skill-icon" /> },
      { name: "MongoDB", icon: <SiMongodb className="skill-icon" /> },
      { name: "PostgreSQL", icon: <BiLogoPostgresql className="skill-icon" /> },
      { name: "ExpressJS", icon: <SiExpress className="skill-icon" /> },
      { name: "Redux", icon: <SiRedux className="skill-icon" /> },
    ],
    certificateUrl: "https://coursera.org/verify/RDDFXPD954KJ",
    downloadUrl: "https://example.com/download2",
    color: "#0A0A23",
  },
  {
    id: 3,
    name: "Getting Started With Python",
    issuer: "University of Michigan",
    issuerLogo: "certifications/python.png",
    completionDate: "November 2023",
    skills: [
      { name: "List", icon: <FaList className="skill-icon" /> },
      { name: "Tuples", icon: <PiBracketsRound className="skill-icon" /> },
      {
        name: "Dynamic Programming",
        icon: <MdDynamicFeed className="skill-icon" />,
      },
      {
        name: "Exception Handling",
        icon: <AiOutlineException className="skill-icon" />,
      },
      { name: "Inheritance", icon: <GrInherit className="skill-icon" /> },
      { name: "Abstraction", icon: <FaUserSecret className="skill-icon" /> },
    ],
    certificateUrl: "https://coursera.org/verify/26SJSNVKK3NT",
    downloadUrl: "https://drive.google.com/file/d/10__dRjtjD1OwCGJTATKGJa1c1NMQBWvN/view?usp=sharing",
    color: "#0A0A23",
  },
  {
    id: 4,
    name: "Google Cloud & Big Data",
    issuer: "Google",
    issuerLogo: "certifications/google.png",
    completionDate: "May 2024",
    skills: [
      { name: "Google Cloud Engine", icon: <SiGooglecloudstorage className="skill-icon" /> },
      { name: "Docker", icon: <FaDocker className="skill-icon" /> },
      { name: "Git", icon: <FaGit className="skill-icon" /> },
      { name: "Network", icon: <FaNetworkWired className="skill-icon" /> },
      { name: "Kubernetes", icon: <SiKubernetes className="skill-icon" /> },
      { name: "Cloud", icon: <SiCloud66 className="skill-icon" /> },
      { name: "Google Cloud", icon: <FaCloud className="skill-icon" /> },
    ],
    certificateUrl: "https://coursera.org/verif y/9BBFF2RK5BWJ",
    downloadUrl: "https://drive.google.com/file/d/1qMnDiZ8GAGKPBMkOTSbg45FwuRdx3A7M/view?usp=sharing",
    color: "#0A0A23",
  },
  
  {
    id: 5,
    name: "Advanced Learning Algorithm",
    issuer: "DeepLearning.AI",
    issuerLogo: "certifications/deep.png",
    completionDate: "September 2025",
    skills: [
      { name: "CNN", icon: <TbMathSymbols className="skill-icon" /> },
      { name: "LSTM", icon: <FaMemory className="skill-icon" /> },
      { name: "RNN", icon: <PiShareNetworkBold className="skill-icon" /> },
      { name: "Tensorflow", icon: <SiTensorflow className="skill-icon" /> },
      { name: "Image Processing", icon: <FaImage className="skill-icon" /> },
      { name: "GPT", icon: <AiOutlineOpenAI className="skill-icon" /> },
      { name: "BERT", icon: <GoCopilot className="skill-icon" /> },
    ],
    certificateUrl: "https://coursera.org/verify/NJB6CTSNXDWL",
    downloadUrl: "https://drive.google.com/file/d/1Yr2E0uS39K2gcjedqj8ddK6Dg1WbLVsD/view?usp=sharing",
    color: "#0A0A23",
  },
  {
    id: 6,
    name: "Fundamentals AI Concepts",
    issuer: "Microsoft",
    issuerLogo: "certifications/microsoft.png",
    completionDate: "September 2025",
    skills: [
      { name: "Python", icon: <DiPython className="skill-icon" /> },
      { name: "AI", icon: <AiFillAndroid className="skill-icon" /> },
      { name: "R", icon: <BiStats className="skill-icon" /> },
      { name: "Neural Network", icon: <BiGlobe className="skill-icon" /> },
      { name: "Deep Learning", icon: <SiDeepin className="skill-icon" /> },
      {
        name: "Machine Translation",
        icon: <HiTranslate className="skill-icon" />,
      },
      {
        name: "Reinforcement Learning",
        icon: <LiaRobotSolid className="skill-icon" />,
      },
    ],
    certificateUrl:
      "https://media.licdn.com/dms/image/v2/D4D2DAQEK-YJyI8OQJQ/profile-treasury-image-shrink_800_800/profile-treasury-image-shrink_800_800/0/1699716621380?e=1739347200&v=beta&t=zryXBKoEiszvMxS5Kdj3oCnUKB7h_oFcV8ljL78z_Ls",
    downloadUrl: "https://media.licdn.com/dms/image/v2/D4D2DAQEK-YJyI8OQJQ/profile-treasury-image-shrink_800_800/profile-treasury-image-shrink_800_800/0/1699716621380?e=1739347200&v=beta&t=zryXBKoEiszvMxS5Kdj3oCnUKB7h_oFcV8ljL78z_Ls",
    color: "#0A0A23",
  },
  {
    id: 7,
    name: "Technical Support",
    issuer: "NIELIT",
    issuerLogo: "certifications/nielt.png",
    completionDate: "September 2025",
    skills: [
      { name: "HTML", icon: <FaHtml5 className="skill-icon" /> },
      { name: "CSS", icon: <FaCss3 className="skill-icon" /> },
      { name: "Javascript", icon: <FaJs className="skill-icon" /> },
      { name: "React", icon: <FaReact className="skill-icon" /> },
      { name: "Tailwind", icon: <RiTailwindCssFill className="skill-icon" /> },
      { name: "SQL", icon: <FaDatabase className="skill-icon" /> },
      {
        name: "Problem Solving",
        icon: <MdOutlineSyncProblem className="skill-icon" />,
      },
    ],
    certificateUrl:
      "https://drive.google.com/file/d/1-BZB3tYxhrtwfHBl7G_9WBWPN5psuveW/view?usp=drivesdk",
    downloadUrl: "https://drive.google.com/file/d/1-BZB3tYxhrtwfHBl7G_9WBWPN5psuveW/view?usp=drivesdk",
    color: "#0A0A23",
  },

  {
    // replace with anyoene not verified
    id: 8,
    name: "Generative Pretrained Transformer",
    issuer: "University Of Glasgow",
    issuerLogo: "certifications/glasgow.png",
    completionDate: "April 2024",
    skills: [
      { name: "Github", icon: <FaGithub className="skill-icon" /> },
      { name: "Docker", icon: <FaDocker className="skill-icon" /> },
      { name: "Git", icon: <FaGit className="skill-icon" /> },
      { name: "Network", icon: <FaNetworkWired className="skill-icon" /> },
      { name: "Kubernetes", icon: <SiKubernetes className="skill-icon" /> },
      { name: "Cloud", icon: <SiCloud66 className="skill-icon" /> },
      { name: "Google Cloud", icon: <FaCloud className="skill-icon" /> },
    ],
    certificateUrl: "https://coursera.org/verif y/LXUP4HSLHKJH",
    downloadUrl: "https://drive.google.com/file/d/1ElDExYaGfmND-zWaOzkCrRSYlcUbwefz/view?usp=sharing",
    color: "#0A0A23",
  },
  {
    id: 9,
    name: "Python Problem Solving",
    issuer: "HackerRank",
    issuerLogo: "certifications/hackerrank.png",
    completionDate: "September 2023",
    skills: [
      { name: "Functions", icon: <RiFunctions className="skill-icon" /> },
      { name: "Modules", icon: <VscFileSubmodule className="skill-icon" /> },
      {
        name: "Dictionary",
        icon: <SiDictionarydotcom className="skill-icon" />,
      },
      { name: "Sets", icon: <IoLibraryOutline className="skill-icon" /> },
      {
        name: "File Handling",
        icon: <IoFileTrayStackedSharp className="skill-icon" />,
      },
      { name: "Classes", icon: <MdClass className="skill-icon" /> },
      { name: "Objects", icon: <FaBimobject className="skill-icon" /> },
    ],
    certificateUrl: "https://www.hackerrank.com/certificates/468b8ee2acff",
    downloadUrl: "https://drive.google.com/file/d/1n3GT6dZPtfOiA7ZYiWxt7jrJtVXwolOM/view?usp=sharing2",
    color: "#0A0A23",
  },

  
  {
    // not verfied
    id: 10,
    name: "Introduction To Artificial Intelligence",
    issuer: "IBM",
    issuerLogo: "certifications/ibm.png",
    completionDate: "September 2025",
    skills: [
      { name: "Python", icon: <DiPython className="skill-icon" /> },
      { name: "AI", icon: <AiFillAndroid className="skill-icon" /> },
      { name: "R", icon: <BiStats className="skill-icon" /> },
      { name: "Neural Network", icon: <BiGlobe className="skill-icon" /> },
      { name: "Deep Learning", icon: <SiDeepin className="skill-icon" /> },
      {
        name: "Machine Translation",
        icon: <HiTranslate className="skill-icon" />,
      },
      {
        name: "Reinforcement Learning",
        icon: <LiaRobotSolid className="skill-icon" />,
      },
    ],
    certificateUrl: "https://coursera.org/verify/CVHFTFDTKXP7",
    downloadUrl: "https://drive.google.com/file/d/1ijfQF81wgBmEbgmlzytVfpDEi5o-Mrdp/view?usp=sharing",
    color: "#0A0A23",
  },

  {
    // not verfied
    id: 11,
    name: "Technical Support Fundamentals",
    issuer: "Google",
    issuerLogo: "certifications/google.png",
    completionDate: "August 2023",
    skills: [
      { name: "Github", icon: <FaGithub className="skill-icon" /> },
      { name: "Docker", icon: <FaDocker className="skill-icon" /> },
      { name: "Git", icon: <FaGit className="skill-icon" /> },
      { name: "Network", icon: <FaNetworkWired className="skill-icon" /> },
      { name: "Kubernetes", icon: <SiKubernetes className="skill-icon" /> },
      { name: "Cloud", icon: <SiCloud66 className="skill-icon" /> },
      { name: "Google Cloud", icon: <FaCloud className="skill-icon" /> },
    ],
    certificateUrl: "https://coursera.org/verify/UQMXY6UG3R2U",
    downloadUrl: "https://drive.google.com/file/d/1luLUPQx8QdtFzLhA5EAqZVjZX8CTA6kz/view?usp=sharing",
    color: "#0A0A23",
  },

  {
    // not verfied
    id: 12,
    name: "Linux Fundamentals",
    issuer: "LearnQuest",
    issuerLogo: "certifications/linux.png",
    completionDate: "September 2025",
    skills: [
      { name: "File Management", icon: <BiFile className="skill-icon" /> },
      {
        name: "Permissions",
        icon: <SiAegisauthenticator className="skill-icon" />,
      },
      {
        name: "Network Configuartion",
        icon: <BiNetworkChart className="skill-icon" />,
      },
      {
        name: "SSH & Remote Access",
        icon: <MdOutlineSettingsRemote className="skill-icon" />,
      },
      {
        name: "Package Management",
        icon: <BiSolidPackage className="skill-icon" />,
      },
      { name: "Linux Distros", icon: <FaUbuntu className="skill-icon" /> },
    ],
    certificateUrl: "https://coursera.org/verify/MZKDE2KAR8UT",
    downloadUrl: "https://drive.google.com/file/d/1mdhXzqeZ2s2iKbxmawwNJXHiOASaZXcn/view?usp=sharing",
    color: "#0A0A23",
  },
  {
    // not verfied
    id: 13,
    name: "Introduction to Android Mobile Application Development",
    issuer: "Meta",
    issuerLogo: "certifications/meta.png",
    completionDate: "April 2023",
    skills: [
      { name: "Github", icon: <FaGithub className="skill-icon" /> },
      { name: "Docker", icon: <FaDocker className="skill-icon" /> },
      { name: "Git", icon: <FaGit className="skill-icon" /> },
      { name: "Network", icon: <FaNetworkWired className="skill-icon" /> },
      { name: "Kubernetes", icon: <SiKubernetes className="skill-icon" /> },
      { name: "Cloud", icon: <SiCloud66 className="skill-icon" /> },
      { name: "Google Cloud", icon: <FaCloud className="skill-icon" /> },
    ],
    certificateUrl: "https://coursera.org/verif y/RDDFXPD954KJ",
    downloadUrl: "https://drive.google.com/file/d/1AVa0rTlRSRb43Hggbb1mKfShFDszEoKW/view?usp=sharing",
    color: "#0A0A23",
  },
  {
    // not verfied
    id: 14,
    name: "Data Structures",
    issuer: "UC SanDiego",
    issuerLogo: "certifications/uc.png",
    completionDate: "March 2023",
    skills: [
      { name: "Github", icon: <FaGithub className="skill-icon" /> },
      { name: "Docker", icon: <FaDocker className="skill-icon" /> },
      { name: "Git", icon: <FaGit className="skill-icon" /> },
      { name: "Network", icon: <FaNetworkWired className="skill-icon" /> },
      { name: "Kubernetes", icon: <SiKubernetes className="skill-icon" /> },
      { name: "Cloud", icon: <SiCloud66 className="skill-icon" /> },
      { name: "Google Cloud", icon: <FaCloud className="skill-icon" /> },
    ],
    certificateUrl: "https://coursera.org/verif y/9GAJSBJS3SGS",
    downloadUrl: "https://drive.google.com/file/d/1Q7V6_O-cboWvBuy4SAJKS-TOtusv4Hbs/view?usp=sharing",
    color: "#0A0A23",
  }


];

// Particle component for background animation
const Particle = ({ delay }) => {
  const style = {
    left: `${Math.random() * 100}%`,
    animationDuration: `${Math.random() * 3 + 2}s`,
    animationDelay: `${delay}s`,
  };

  return <div className="cert-particle" style={style} />;
};

// Background animation component
const AnimatedBackground = () => {
  return (
    <div className="certifications-background">
      {[...Array(15)].map((_, index) => (
        <Particle key={index} delay={index * 0.3} />
      ))}
    </div>
  );
};

// Certificate card component
const CertificationCard = ({ certification }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = (e) => {
    e.target.src = "/images/placeholder-logo.png"; // Fallback image
  };

  return (
    <div
      className={`certification-card ${isExpanded ? "expanded" : ""}`}
      style={{ "--card-accent-color": certification.color }}
    >
      <div className="certification-header">
        <div className="logo-container">
          <div className="logo-wrapper">
            <img
              src={certification.issuerLogo}
              alt={`${certification.issuer} logo`}
              className={`issuer-logo ${imageLoaded ? "loaded" : ""}`}
              onLoad={handleImageLoad}
              onError={handleImageError}
            />
          </div>
        </div>
        <div className="certification-info">
          <h3 className="certification-name">{certification.name}</h3>
          <p className="certification-issuer">{certification.issuer}</p>
          <div className="certification-date">
            <FaCalendarAlt className="date-icon" />
            <span>{certification.completionDate}</span>
          </div>
        </div>
        <button
          className="expand-button"
          onClick={() => setIsExpanded(!isExpanded)}
          aria-label={isExpanded ? "Collapse details" : "Expand details"}
        >
          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
        </button>
      </div>

      <div className="certification-details">
        <div className="skills-section">
          <h4 className="skills-title">
            <FaAward className="skills-icon" />
            Skills & Technologies
          </h4>
          <div className="skills-container">
            {certification.skills.map((skill, index) => (
              <div
                key={index}
                className="skill-tag"
                style={{
                  "--skill-color": certification.color,
                }}
              >
                {skill.icon}
                <span>{skill.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="certification-actions">
          {certification.certificateUrl && (
            <a
              href={certification.certificateUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="action-button view-button"
            >
              <FaExternalLinkAlt />
              <span>View Certificate</span>
            </a>
          )}
          {certification.downloadUrl && (
            <a
              href={`https://drive.google.com/uc?export=download&id=${
                certification.downloadUrl.match(/\/d\/(.*?)\/view/)?.[1]
              }`}
              download
              className="action-button download-button"
            >
              <FaDownload />
              <span>Download PDF</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

// Main Certifications component
const Certifications = () => {
  const [isVisible, setIsVisible] = useState(false);

  const observer = useCallback((node) => {
    if (node !== null) {
      const observerInstance = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
            }
          });
        },
        { threshold: 0.1 }
      );

      observerInstance.observe(node);

      return () => {
        node && observerInstance.unobserve(node);
      };
    }
  }, []);

  useEffect(() => {
    // Add particles on component mount
    const addParticles = () => {
      const particles = document.querySelectorAll(".cert-particle");
      particles.forEach((particle) => {
        particle.style.animationDuration = `${Math.random() * 3 + 2}s`;
        particle.style.left = `${Math.random() * 100}%`;
      });
    };

    addParticles();
    const interval = setInterval(addParticles, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="certifications-section"
      id="certifications"
      ref={observer}
    >
      <AnimatedBackground />

      <div className={`certifications-header ${isVisible ? "fade-in" : ""}`}>
        <h2>Professional Certifications</h2>
        <p>
          Showcasing my commitment to continuous learning and professional
          development through industry-recognized certifications and
          achievements.
        </p>
      </div>

      <div className="certifications-grid">
        {certifications.map((certification, index) => (
          <div
            key={certification.id}
            className="fade-in"
            style={{
              animationDelay: `${index * 0.2}s`,
              opacity: isVisible ? 1 : 0,
            }}
          >
            <CertificationCard certification={certification} />
          </div>
        ))}
      </div>
    </section>
  );
};

// Custom hook for intersection observer
const useIntersectionObserver = (ref, options) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting);
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref, options]);

  return isIntersecting;
};

export default Certifications;
